// src/components/Footer.js
import React from 'react';
import { FaTwitter, FaTelegram } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="p-4 bg-black text-gray-400 border-t border-gray-800 text-sm">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 md:px-4">

                {/* Left Side - Copyright */}
                <p className="text-center md:text-left">© {new Date().getFullYear()} rapid</p>

                {/* Middle - Links */}
                <div className="flex space-x-2 justify-center">
                    <a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a>
                    <span>|</span>
                    <a href="/terms-and-conditions" className="hover:text-white transition-colors">Terms and Conditions</a>
                </div>

                {/* Right Side - Social Icons */}
                <div className="flex space-x-4 justify-center">
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                        <FaTwitter className="text-lg" />
                    </a>
                    <a href="https://telegram.org" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                        <FaTelegram className="text-lg" />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
